import React, { useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import Styles from './styles.module.scss';
import {getReferrals} from "../../store/cabinet/action";
import {useTranslation} from "react-i18next";

const CabinetReferralTable = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const referrals = useSelector(store => store.cabinet.referrals);

    // Создаем реф для элемента "сентинела"
    const loadMoreRef = useRef(null);


    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting) {
                    if (referrals?.referrals?.current_page < referrals?.referrals?.last_page) {
                        // Передаем следующую страницу в action
                        dispatch(getReferrals(referrals?.referrals?.current_page + 1));
                    }
                }
            },
            {
                root: null, // отслеживание относительно viewport
                rootMargin: '0px',
                threshold: 1.0, // элемент считается видимым, когда полностью виден
            }
        );

        if (loadMoreRef.current) {
            observer.observe(loadMoreRef.current);
        }

        return () => {
            if (loadMoreRef.current) {
                // eslint-disable-next-line react-hooks/exhaustive-deps
                observer.unobserve(loadMoreRef.current);
            }
        };
    }, [dispatch, referrals]);

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap} ${Styles.ftfCard}`}>
                <div className={`${Styles.contentWrapTitle}`}>{t('Статистика рефералов')}:</div>
                <div className={Styles.contentBox}>
                    <div className={Styles.contentBoxTitleRow}>
                        <div className={Styles.contentBoxTitleRowItem}>{t('Никнейм')}</div>
                        <div className={Styles.contentBoxTitleRowItem}>{t('Оборот средств')}</div>
                        <div className={Styles.contentBoxTitleRowItem}>{t('Ваш бонус')}</div>
                    </div>
                    <div className={Styles.contentBoxTable}>
                        {referrals?.data ? referrals.data.map((item, index) => (
                            <div className={Styles.contentBoxTableRow} key={'referralsRow' + index}>
                                <div className={Styles.contentBoxTableRowItem}>{item.username}</div>
                                <div className={Styles.contentBoxTableRowItem}>{item.coins * 1}</div>
                                <div className={Styles.contentBoxTableRowItem}>{item.bonus} CFP</div>
                            </div>
                        )) : null}
                        <div ref={loadMoreRef} />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CabinetReferralTable;